import React from 'react'
import { EventsOfTask } from 'pages/Tasks/types'
import TimelineBadge from 'redesign/components/molecules/timeline-badge'
import { TIMELINE_BADGE_VARIANTS } from 'redesign/components/molecules/timeline-badge/constants'
import type { TimelineBadgeProps } from 'redesign/components/molecules/timeline-badge/types'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getCommentButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-comment-button'
import type { MessageDrawerProps } from 'redesign/services/timeline-action-button/types'

export const getConfirmRequestDeleteButton = ({
  setMessageDrawerProps,
  t,
  sendEvent,
  refetch,
}: ResolveActionButtonsProps) => {
  const confirmRequestBadgeProps: TimelineBadgeProps = {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: 'timeline.badge.deletionConfirm',
    tooltipText: 'absenceRequest.deletionConfirmed.tooltipManager',
    testId: 'task-status_deletion-confirmed',
  }

  const confirmRequestDrawerProps: Partial<MessageDrawerProps> = {
    headerLabel: <TimelineBadge {...confirmRequestBadgeProps} />,
    placeholder: t('absenceRequest.requestDeletion.comment.placeholder'),
    commentText: t('absenceRequest.confirmDeletion.body'),
    isRequired: false,
  }
  const confirmRequestButtonProps = {
    label: t('absenceRequest.buttons.confirmDeletion'),
    testId: 'absence-request_action-confirm_deletion',
  }

  return getCommentButton({
    t,
    sendEvent,
    refetch,
    setMessageDrawerProps,
    taskEvent: EventsOfTask.absenceRequestAcceptDeletion,
    drawerProps: confirmRequestDrawerProps,
    buttonProps: confirmRequestButtonProps,
  })
}
